<template>
  <tr>
    <td class="plantmore-product-remove">
        <a
        href="#"
        @click="removeCartItem()">
            <i class="text-danger fa fa-times"/>
        </a>
    </td>
    <td class="plantmore-product-thumbnail">
        <router-link :to="{ name: 'product', params: { itemID: cartItem.itemID, WarehouseID: cartItem.item.WarehouseID }}">
            <img
            :src="getImageURL()"
            :alt="cartItem.item.ItemID"
            height="90"
            width="90">
        </router-link>
    </td>
    <td class="plantmore-product-name">
        <router-link :to="{ name: 'product', params: { itemID: cartItem.itemID, WarehouseID: cartItem.item.WarehouseID }}">
            {{ cartItem.itemID }} - {{ cartItem.itemDescription }}
        </router-link>
    </td>
    <td>{{ cartItem.compositionID }}</td>
    <td>{{ cartItem.amount }}</td>
    <!-- <td class="plantmore-product-quantity"><input type="number" v-model="itemAmount"></td> -->
    <td v-html="borrowPeriod"/>
  </tr>
</template>

<script>
import CartService from '@/services/CartService.js'
import moment from 'moment'

export default {
    props: {
        'cartItem': {
            type: Object,
            required: true
        }
    },
    computed: {
        itemAmount: {
            get: function () { return this.cartItem.amount },
            set: function (newAmount) {
                CartService.updateCartItemAmount(this.cartItem, Number(newAmount))
            }
        },
        borrowPeriod: function () {
            let borrowPeriod = moment(this.cartItem.start).format('DD-MM-YYYY')

            if (this.cartItem.end) {
                borrowPeriod += ' <strong>t/m</strong> ' + moment(this.cartItem.end).format('DD-MM-YYYY')
            }
            return borrowPeriod
        }
    },
    methods: {
        async removeCartItem () {
            let cartItemID = this.cartItem.cartItemID
            CartService.removeCartItem(cartItemID)
        },
        getImageURL () {
            return CartService.getImageURL(this.cartItem.item)
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Cart/CartItem.vue